import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
const imgWidth = {
    width: '100%',
};

const Dispatch = (dispatch) => {
    return {
        reserva: (e) =>{
            let index = e.target.getAttribute('data-index');
            const action = {
                type: 'reserva',
                index: index
            }
            dispatch(action);
        }
    }
}

class EventCardTicket extends Component {
    componentDidMount=()=> {
        document.getElementById('event-'+this.props.index).innerHTML = this.props.children;
    }
    render(){
        return (
        <div className="card__events">
            <div className="card__events--item">
                <div className="row card__events">
                    <div className="card__events--image col-lg-3 col-sm-12">
                        <img className="mr-3" style={imgWidth} src={this.props.featuredImage} alt={this.props.name} />
                    </div>
                    <div className="card__events--details col-lg-9 col-sm-12">
                        <div className="card__events--name">
                            <h4>{this.props.name}</h4>
                        </div>
                        <div className="card__events--content">
                                <p className="paragraph" id={"event-"+this.props.index}></p>
                        </div>
                        <div className="card__events--pricing d-block" style={{marginTop: '18px'}}>
                            <div className="d-inline">
                                <span className="card__events--capacityText">
                                    Fecha: <strong>24/09/2018</strong> | Capacidad Máxima: {this.props.capacity}
                                </span>
                            </div>
                            <div className="d-inline float-right">
                                <a onClick={(e) => { 
                                    this.props.selectEvent(e.target.getAttribute('data-index'));
                                    this.props.openModalTicket()}} data-index={this.props.index} className="btn btn-events">Ver Reservacion
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
}

EventCardTicket.propTypes = {
    name: PropTypes.string.isRequired,
    capacity: PropTypes.number.isRequired,
    featuredImage: PropTypes.string.isRequired,
}
export default connect(null,Dispatch)(EventCardTicket);


// WEBPACK FOOTER //
// ./src/Components/Events/eventCardTicket.js